import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Form, Input, Space } from 'antd';
import LoyaltyPoinSettinService from "services/loyalty_point";
import ImagePicker from "components/pickers/image/ImagePicker"
import { useForm, useWatch } from "antd/es/form/Form";
import { useApp } from 'contexts/app';
import InputNumber from 'components/input-number';
import { formatCurrency } from "utils/number"
const service = new LoyaltyPoinSettinService();

const LoyaltySetting = () => {
    const [form] = useForm();
    const { showLoading, showNotify } = useApp();
    const [oldSetting, setOldSetting] = useState({})
    const amountValue = Form.useWatch('amount', form);
    useEffect(() => {
        loadData();
    }, []);



    const loadData = async () => {
        var setting = await service.getLoyaltyPoint();
        form.setFieldsValue(setting);
        setOldSetting(setting);
    }

    const onFinish = async values => {
        // console.log('Success:', values);
        showLoading(true);
        await service.saveLoyaltyPoint(values)
        await loadData();
        showLoading(false);
        showNotify("Đã cập nhật")
    };
    const onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
    };
    return (


        <Form
            form={form}
            name="basic"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ maxWidth: 600 }}
            initialValues={{ remember: true }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
        >

            <Form.Item
                label="Tích điểm"
                name="on"
                rules={[{
                    required: true,

                },

                ]}
                valuePropName='checked'
            >
                <Checkbox></Checkbox>
            </Form.Item>
            <Form.Item
                label="Chi tiêu"
                name="amount"
                rules={[{
                    required: true,

                },

                ]}
            >
                <InputNumber suffix={"đồng được  1 xu"} style={{ width: 300 }} />
            </Form.Item>
            <Form.Item label="Diễn giải">
                <div>
                    {(amountValue && amountValue > 0) &&
                        <div>Với hoá đơn 1.000.000 đồng khách sẽ tích được {formatCurrency( Math.round(1000000 / amountValue))} xu</div>
                    }
                    <div>
                        1 xu  =  1 đồng khi  khách hàng sử dụng xu 
                    </div>
                </div>
                

            </Form.Item>

            <Form.Item label={null}>
                <Button type="primary" htmlType="submit">
                    Cập nhật
                </Button>
            </Form.Item>
        </Form>
    )
}
export default LoyaltySetting;